<template>
  <v-chip :href="url" color="#3283f7" label small>
    <slot name="icon"></slot>
    <span class="suus-label">
      <slot> {{ content }}</slot>
    </span>
  </v-chip>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "Label",
  props: {
    url: {
      type: String,
      required: false,
    },
    content: {
      type: String,
      required: false,
    },
  },
})
</script>
<style scoped>
.suus-label {
  text-overflow: ellipsis;
  overflow: hidden;
  color: white;
  text-transform: uppercase;
  font-weight: bold !important;
  padding: 3px 0px 2px 2px !important;
  margin-left: 4px;
}
</style>
